module.exports = __webpack_public_path__ + "static/circularstd-medium-ae1f1d3d54ef7ceebbebc94afec34a41.woff2";